module.exports = __webpack_public_path__ + "static/media/google.e44b23e8.svg";